import { Options, Vue } from 'vue-class-component';
import {
  getThermoPreferencesSections,
  ThermoSettingsPreference,
  loadThermoPreferencesSectionsComponents,
} from '@/core/utils/thermo-preferences.utils';
import { IThermoRoomObjectDTO } from 'client-generator/generated-clients/plants';
import { PropType } from 'vue';

@Options({
  name: 'ThermostatPreferences',
  props: {
    roomObject: {
      type: Object as PropType<IThermoRoomObjectDTO>,
      required: true,
    },
  },
  components: loadThermoPreferencesSectionsComponents(),
})
export default class ThermostatPreferences extends Vue {
  roomObject!: IThermoRoomObjectDTO;
  currentPreference: ThermoSettingsPreference | null = null;

  get preferencesList(): ThermoSettingsPreference[] {
    return getThermoPreferencesSections();
  }

  preferenceComponent(preferenceComponentName: string) {
    return `Preference${preferenceComponentName}`;
  }
}
